module.exports = __webpack_public_path__ + "assets/fonts/Foco-Regular-838c87ec8d589a1ed3d6f578298544f9.otf";